//these 2 values are correlated. They help round and calculate the values of commissionNightz, ditlprice and price
import { TICKET_CONSTANTS } from "../config/constants/ticket-constants";

export const round = (number, precision = TICKET_CONSTANTS.FIXED_PRECISION) => {
  return Math.round(number * precision) / precision;
};
export const calculateNCommissionAbsoluteValue = (
  nightzCommission,
  price
) => {
  return round((parseFloat(nightzCommission) * price) / 100);
};

export const fCommission = (
  price,
  commission,
  commissionPaidByUser
) => {
  return commissionPaidByUser ? round(price * (1 + commission / 100)) : price;
};